import { createAction, union } from '@ngrx/store';

import { CommunityDto } from '../dto';
import { LeasingAgentDto } from '../dto/leasing-agent.dto';

export const initialize = createAction('[User] Initialize user state');

export const changeStartDate = createAction('[User] Change start date', (date: string) => ({
  date,
}));

export const changeEndDate = createAction('[User] Change end date', (date: string) => ({ date }));

export const loadCommunities = createAction('[User] Load communities');

export const loadCommunitiesFail = createAction(
  '[User] Load communities fail',
  (communities: CommunityDto[]) => ({ communities }),
);

export const loadCommunitiesSuccess = createAction(
  '[User] Load communities success',
  (communities: CommunityDto[]) => ({ communities }),
);

export const selectCommunities = createAction(
  '[User] Select communities',
  (communities: CommunityDto[]) => ({ communities }),
);

export const selectLeasingAgents = createAction(
  '[User] Select leasing agents',
  (leasingAgents: LeasingAgentDto[]) => ({ leasingAgents }),
);

const all = union({
  initialize,
  changeStartDate,
  changeEndDate,
  loadCommunities,
  loadCommunitiesFail,
  loadCommunitiesSuccess,
  selectCommunities,
  selectLeasingAgents,
});
export type Actions = typeof all;
